<span #counter class="counter {{ class }}"></span>
